

exports.__esModule = true;

var _squid = require('squid');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

var _route = require('xo-login-components/src/password-recovery-overlay/route');

var _route2 = _interopRequireDefault(_route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Route.extend('$xoPageCreatePasswordRoute', {
    path: 'createPassword',
    directive: _directive2['default'],
    trackingData: {
        fptiState: 'quick_security_check'
    },
    params: {
        targetPage: null
    },
    children: [{
        route: _route2['default'],
        props: function props() {
            var _this = this;

            return {
                token: this.token,
                cancel: function cancel() {
                    return _this.goto('^');
                },
                success: function success() {
                    return _this.goto('checkout.login');
                }
            };
        }
    }]
});


_squid.$Route;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-create-password/route.js
 ** module id = 448
 ** module chunks = 1
 **/